/**
 * @param {string} title
 * @param {React.ReactNode} icon
 */
const PageHeading = (props) => {
	const { title, icon } = props;

	return (
		<h1 className="text-xl font-bold text-akgreenest flex items-center gap-2">
			{icon}
			{title}
		</h1>
	);
};

export default PageHeading;
